export default {
    props: {
        controlsAttribution: {
            type: Boolean,
            default: undefined,
            kComposite: 'controls.attribution'
        }, 
        controlsAttributionPosition: {
            type: String,
            default: undefined,
            kComposite: 'controls.attribution.position'
        }, 
        controlsNavigator: {
            type: Boolean,
            default: undefined,
            kComposite: 'controls.navigator'
        }, 
        controlsNavigatorPosition: {
            type: String,
            default: undefined,
            kComposite: 'controls.navigator.position'
        }, 
        controlsZoom: {
            type: Boolean,
            default: undefined,
            kComposite: 'controls.zoom'
        }, 
        controlsZoomPosition: {
            type: String,
            default: undefined,
            kComposite: 'controls.zoom.position'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-map-vue-wrapper/src/KendoMap/Controls.js